import { UseMutationResult, useMutation } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { IEntityGroup, api } from "../../utils";

export interface IUpdateEntityGroupParameter {
    name: string;
    description: string;
    groupId: string;
}

export const useUpdateEntityGroup = (
    queryKey: string | string[],
): UseMutationResult<IEntityGroup, unknown, IUpdateEntityGroupParameter> => {
    const auth = useAuth();
    return useMutation({
        mutationFn: async (parameters: IUpdateEntityGroupParameter) => {
            if (!auth.token) {
                throw new Error(
                    "Cannot update entity group without authorization token.",
                );
            }

            return await api.EntityGroup.update({
                ...parameters,
                token: auth.token,
            });
        },
    });
};
